module.exports = __webpack_public_path__ + "img/d1.860a06c6.jpg";